$(document).ready(function() {
    if (!document.querySelector('body.course') && !document.querySelector('.mobile-nav-wrapper')) {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const nav = document.querySelector('.mobile-nav-wrapper');
    let wasClosedByScroll = false;

    ScrollTrigger.create({
        trigger: document.body,
        start: "top+=250 top",
        once: false,
        onEnter() {
            if (window.innerWidth > 1024) {
                if (nav.classList.contains('open')) {
                    wasClosedByScroll = true;
                    nav.classList.remove('open');
                }
            }
        },
        onLeaveBack() {
            if (window.innerWidth > 1024) {
                if (wasClosedByScroll && !nav.classList.contains('open')) {
                nav.classList.add('open');
                wasClosedByScroll = false;
                }
            }
        }
    });


    /*
    if (!document.querySelector('#sticky-summary')) {
        return;
    }
    
    const stickyContainer = document.querySelector('#sticky-summary');
    const stickyElement = stickyContainer.querySelector('.course-information');

    gsap.registerPlugin(ScrollTrigger);

    if (!stickyElement) {
        return;
    }

    ScrollTrigger.create({
        trigger: stickyElement,
        start: "top top+=210",
        end: "bottom top",
        onEnter: () => stickyContainer.classList.add('is-stuck-at-top'),
        onLeaveBack: () => stickyContainer.classList.remove('is-stuck-at-top'),
        markers: true
    });
    
    
    if (!document.querySelector('.course-page--header__mask')) {
        return;
    }

    const maskImage = document.querySelector('.course-page--header__mask__inner');
    const maskImageWrapper = document.querySelector('.course-page--header__mask');

    if (maskImage && maskImageWrapper) {
        gsap.set(maskImage, { scale: 1 });

        const maskZoomTL = gsap.timeline({
            scrollTrigger: {
                trigger: maskImageWrapper,
                start: "top top",
                end: "+=100vh", 
                scrub: true,
                pin: true,
                pinSpacing: true,
                //markers: true
            }
        });

        maskZoomTL.to(maskImage, {
            scale: 2,
            ease: "power4.out",
            duration: 2
        });
    }
    */
})